module.exports = __webpack_public_path__ + "img/SPC_Sword1 Clean OneMaterial.fbcb16b3.png";